import { CheckBox, Container, Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import { ScrollView, TouchableOpacity } from "react-native";
import { useState } from "react";
import React from "react";
import { useDispatch } from "react-redux";
import {
  saveGroup,
  useSearchGroupSlice,
} from "@redux/slices/searchGroupsSlice";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { ToastTypes, showToast } from "../VDBToast/util";
import { useTranslation } from "react-i18next";
import {
  DefaultSearchGroupScreen,
  GroupItemProps,
  GroupProps,
  OtherGroupsProps,
} from "./types";

const SectionContainer = ({ data, productType }: DefaultSearchGroupScreen) => {
  return (
    <>
      {data.map((item: GroupProps, index: number) => (
        <>
          <React.Fragment key={index}>
            <Container>
              <GroupItem
                productType={productType}
                groupId={item.groupId}
                group_info={item.groupInfo}
                {...item}
              />
            </Container>
          </React.Fragment>
        </>
      ))}
    </>
  );
};

const OtherGroups = ({ groupData, productType }: OtherGroupsProps) => {
  if (!groupData) {
    return null;
  }
  return (
    <ScrollView>
      {groupData.map((group, index) => (
        <React.Fragment key={`${index - group.id}`}>
          <SectionContainer
            key={group.id}
            data={[
              {
                title: group.name,
                groupId: group.id,
                group_info: group.group_info,
              },
            ]}
            productType={productType}
          />
          {index !== groupData.length - 1 && <LineView key={`line_${index}`} />}
        </React.Fragment>
      ))}
    </ScrollView>
  );
};

const GroupItem = ({
  title,
  groupId,
  productType,
  group_info,
}: GroupItemProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const { selectedGroups } = useSearchGroupSlice();
  const dispatch = useDispatch();
  const selectedGroupIds = selectedGroups[productType] ?? [];
  const numChecked = selectedGroupIds.length;

  const isIdIncluded = selectedGroupIds.includes(groupId);
  const [groupChecked, setIsGroupChecked] = useState(isIdIncluded);
  const [checkboxKey, setCheckboxKey] = useState(Math.random());

  const handlePress = () => {
    if (groupChecked) {
      if (numChecked === 1) {
        showToast(
          undefined,
          t("searchGroup.toast.title"),
          ToastTypes.ERROR,
          true,
          true
        );
        setCheckboxKey(Math.random());
        return;
      }
      const newGroups = selectedGroupIds.filter((id: string) => id !== groupId);
      dispatch(saveGroup({ [productType]: newGroups }));
      setIsGroupChecked(false);
    } else {
      const newGroups = [...selectedGroupIds, groupId];
      dispatch(saveGroup({ [productType]: newGroups }));
      setIsGroupChecked(true);
    }
  };

  return (
    <Overlay>
      <TouchableOpacity>
        <CheckBox
          key={checkboxKey}
          labelColor={groupChecked ? theme["core-05"] : theme["core-06"]}
          style={groupChecked ? typography["Body-M"] : typography["Body-R"]}
          text={title}
          isChecked={groupChecked}
          onPress={handlePress}
        />
        {group_info && (
          <>
            <Spacer size={SpaceType.Basic} />
            <VDBText color={theme["core-06"]} style={typography["Minor-R"]}>
              {group_info}
            </VDBText>
          </>
        )}
      </TouchableOpacity>
    </Overlay>
  );
};

const Overlay = styled.View`
  padding-vertical: ${SpaceType.Double}px;
  flex-direction: column;
  justify-content: space-between;
`;
const LineView = styled.View`
  height: 1px;
  background-color: ${({ theme }) => theme["core-03"]};
`;

export default OtherGroups;
